import * as React from 'react'

import { InfoIcon } from 'lucide-react'

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '~/client/src/shared/components/shadcn-ui/tooltip'
import Localization from '~/client/src/shared/localization/LocalizationManager'

const ColumnTitle: React.FC<{ label: string; info: string }> = ({
  label,
  info,
}) => (
  <div className="tw:flex tw:w-28 tw:shrink-0 tw:items-center tw:gap-1.5">
    {label}
    <Tooltip>
      <TooltipTrigger
        type="button"
        aria-label={info}
        className="tw:inline-flex tw:shrink-0 tw:cursor-default tw:items-center tw:text-muted-foreground tw:hover:text-foreground"
      >
        <InfoIcon size={16} aria-hidden="true" />
      </TooltipTrigger>
      <TooltipContent>{info}</TooltipContent>
    </Tooltip>
  </div>
)

const AppTogglesHeader: React.FC = () => (
  <div className="tw:flex tw:h-8 tw:items-center tw:gap-2 tw:border-b tw:border-input-soft tw:text-app-dense tw:text-muted-foreground">
    <div className="tw:flex-1">{Localization.translator.app}</div>
    <ColumnTitle
      label={Localization.translator.visibility}
      info={Localization.translator.appsVisibilityInfo}
    />
    <ColumnTitle
      label={Localization.translator.defaultPage}
      info={Localization.translator.defaultPageInfo}
    />
  </div>
)

export default AppTogglesHeader
